import React, { useEffect, useState } from "react";
import { API, getToken } from "@/lib/api";

/**
 * Avatar with optional uploaded image.
 * Priority: user.avatar (storage path) image → initials on gradient.
 */
export function Avatar({ user, size = 40, className = "" }) {
  const initials = (user?.username || "?").slice(0, 2).toUpperCase();
  const grad = user?.avatar_gradient || "from-fuchsia-500 to-pink-500";
  const [blobUrl, setBlobUrl] = useState(null);
  const [errored, setErrored] = useState(false);

  const storagePath = user?.avatar;
  const hasImage = !!storagePath && !errored;

  useEffect(() => {
    if (!storagePath) {
      setBlobUrl(null);
      return;
    }
    let url = null;
    let cancelled = false;
    const token = getToken();
    fetch(`${API}/files/${storagePath}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then(async (r) => {
        if (!r.ok) throw new Error("avatar fetch failed");
        const blob = await r.blob();
        if (cancelled) return;
        url = URL.createObjectURL(blob);
        setBlobUrl(url);
      })
      .catch(() => setErrored(true));
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [storagePath]);

  return (
    <div
      className={`rounded-full bg-gradient-to-br ${grad} flex items-center justify-center font-display font-bold text-white ring-2 ring-black/40 shrink-0 overflow-hidden relative ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.38 }}
      data-testid="user-avatar"
    >
      {hasImage && blobUrl ? (
        <img src={blobUrl} alt={user?.username || ""} className="w-full h-full object-cover" />
      ) : (
        <span>{initials}</span>
      )}
    </div>
  );
}
